module.exports = ["area","base","br","col","embed","hr","img","input","keygen","link","menuitem","meta","param","source","track","wbr"]


//////////////////
// WEBPACK FOOTER
// ./src/void-elements.json
// module id = 7
// module chunks = 0